exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".limit-list {\n  max-height: 250px; }\n\nul {\n  overflow-y: auto;\n  max-height: 250px;\n  min-height: 250px;\n  border: 1px solid rgba(0, 0, 0, 0.18); }\n\ninput {\n  width: 100%;\n  padding: 4px 4px 4px 15px;\n  border: 1px solid #ddd;\n  margin-bottom: 5px; }\n\nul {\n  /* Remove default list styling */\n  list-style-type: none;\n  padding: 0;\n  margin: 0; }\n\nul li a {\n  border: 1px solid #ddd;\n  /* Add a border to all links */\n  margin-top: -1px;\n  /* Prevent double borders */\n  background-color: #f6f6f6;\n  /* Grey background color */\n  padding: 5px 15px;\n  /* Add some padding */\n  text-decoration: none;\n  /* Remove default text underline */\n  color: black;\n  /* Add a black text color */\n  display: block;\n  /* Make it into a block element to fill the whole list */ }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/component/list-filter/styles.scss
// module id = ../../../../../src/app/shared/component/list-filter/styles.scss
// module chunks = main